import React, { useEffect, useState } from "react";
import {
  List, Avatar, Spin, Typography,
  Checkbox, Button, message
} from "antd";

const { Title } = Typography;
const LS_KEY   = "simolapps_state";
const API      = {
  fav       : "https://simolmedia.tw1.ru/api/get_favorite_tracks.php",
  tracksById: "https://simolmedia.tw1.ru/api/get_tracks_by_ids.php",
  queue     : id => `https://simolmedia.tw1.ru/api/get_download_queue.php?user_id=${id}`,
  purchased : "https://simolmedia.tw1.ru/api/get_purchased_tracks.php",
  addQueue  : "https://simolmedia.tw1.ru/api/add_to_download_queue.php"
};

export default function FavoriteTracks() {
  const [tracks, setTracks]   = useState([]);
  const [selected,setSelected]= useState([]);

  const [queueIds , setQ] = useState([]);
  const [purchased,setP]  = useState([]);
  const [loading  , setL] = useState(true);

  const userId = (()=> {
    try { return JSON.parse(localStorage.getItem(LS_KEY))?.user?.id ?? null; }
    catch { return null; }
  })();

  /* ---------- загрузка ---------- */
  useEffect(() => {
    if (!userId) { setL(false); return; }

    const fetchJSON = (url, body) =>
      fetch(url,{method:"POST",headers:{ "Content-Type":"application/json" },body:JSON.stringify(body)})
      .then(r=>r.json());

    (async()=>{
      try{
        /* избранное -> id */
        const fav = await fetchJSON(API.fav,{ user_id:userId });
        if (!fav.success || !fav.tracks.length){ setL(false); return; }

        /* полная инфа */
        const ids = fav.tracks.map(t=>t.track_id);
        const inf = await fetchJSON(API.tracksById,{ track_ids:ids });
        if (inf.success) setTracks(inf.tracks);

        /* корзина + купленные */
        const [q,p] = await Promise.all([
          fetch(API.queue(userId)).then(r=>r.json()),
          fetchJSON(API.purchased,{ user_id:userId })
        ]);
        setQ((q.paid ?? q.track_ids ?? []).map(t=>Number(t.id||t)));
        setP((p.track_ids ?? []).map(Number));

        /* DEBUG */
        console.log("[FAV] треки:", inf.tracks);
        console.log("[FAV] купленные:", p.track_ids);
        console.log("[FAV] в корзине:", q.paid ?? q.track_ids);

      }catch(e){ console.error(e); message.error("Ошибка загрузки"); }
      finally{ setL(false); }
    })();
  }, [userId]);

  /* ---------- helpers ---------- */
  const toggle = (id, disabled)=>{
    if (disabled){ message.info("Трек уже куплен"); return; }
    setSelected(prev =>
      prev.includes(id) ? prev.filter(x=>x!==id) : [...prev,id]
    );
  };

  const add = async ()=>{
    if (!selected.length) return;
    try{
      const r = await fetch(API.addQueue,{
        method:"POST",
        headers:{ "Content-Type":"application/json" },
        body:JSON.stringify({ user_id:userId, track_ids:selected })
      }).then(x=>x.json());

      if (r.success){
        message.success("Добавлено в корзину");
        setQ(q=>[...q,...selected]);
        setSelected([]);
      }else{ message.error(r.message||"Ошибка добавления"); }
    }catch{ message.error("Ошибка сети"); }
  };

  /* ---------- render ---------- */
  if (loading) return <Spin style={{margin:40}} tip="Загрузка..."/>;
  if (!tracks.length) return <p>У вас нет понравившихся треков</p>;

  return (
    <div style={{padding:20}}>
      <Title level={3}>Избранные треки</Title>

      <List
        itemLayout="horizontal"
        dataSource={tracks}
        renderItem={t=>{
          const disabled = purchased.includes(t.id);
          const checked  = disabled || queueIds.includes(t.id) || selected.includes(t.id);

          const cover = t.track_cover_photo
            ? `https://audiobuzz-web.tmweb.ru/uploads/thumbnails/media/${t.track_cover_photo}`
            : "https://audiobuzz-web.tmweb.ru/uploads/thumbnails/default_cover.jpg";

          return (
            <List.Item>
              <Checkbox
                disabled={disabled}
                checked={checked}
                onChange={()=>toggle(t.id,disabled)}
                style={{marginRight:12,opacity:disabled?0.4:1}}
              />
              <List.Item.Meta
                avatar={<Avatar shape="square" size={64} src={cover}/>}
                title={t.title}
                description={`Жанр: ${t.genre || "не указан"} | ${Math.floor(t.duration/1000)} сек`}
              />
            </List.Item>
          );
        }}
      />

      {!!selected.length && (
        <div style={{marginTop:20}}>
          <Button type="primary" onClick={add}>
            Добавить в корзину ({selected.length})
          </Button>
        </div>
      )}
    </div>
  );
}
